module.exports = __webpack_public_path__ + "img/4.cf484e10.png";